const fetch = require('app/www/libs/client/fetch');
const RESOURCE = require('app/configs/_routes').program.api.base;

module.exports = {

    getSchedule(params) {
        const {
            start,
            eventId,
            channelId,
            programId,
            scheduleViewStrategy,
        } = params;
        const path = RESOURCE.replace(/\:programId\(\\d\+\)/gi, String(programId));
        const skipUploaded = params.skipUploaded || 0;

        let query = {
            start,
            eventId,
            channelId,
            skipUploaded,
            formatSchedule: scheduleViewStrategy,
            updateSchedule: true,
        };

        return fetch(path, query);
    },

};
